// Add your custom JS here.

document.addEventListener("DOMContentLoaded", function () {

    let navbarNavDropdown = document.getElementById("navbarNavDropdown");
    let searchModal = document.getElementById("searchModal");

    if (navbarNavDropdown) {
        navbarNavDropdown.addEventListener("show.bs.collapse", function () {
            document.body.classList.add("menu-visible");
            document.body.classList.remove("search-visible");
            if (searchModal.classList.contains("show")) {
                searchModal.classList.remove("show");
                navbarNavDropdown.collapse();
            }
        });

        navbarNavDropdown.addEventListener("hide.bs.collapse", function () {
            document.body.classList.remove("menu-visible");
            document.body.classList.remove("search-visible");
            searchModal.classList.remove("show");
        });
    }

    if (searchModal) {
        searchModal.addEventListener("show.bs.collapse", function () {
            document.body.classList.add("search-visible");
            document.body.classList.remove("menu-visible");
            setTimeout(() => document.getElementById('search-modal').focus(), 0);
        });

        searchModal.addEventListener("hide.bs.collapse", function () {
            document.body.classList.remove("search-visible");

            if (navbarNavDropdown && navbarNavDropdown.classList.contains("show")) {
                navbarNavDropdown.classList.remove("show");
            }

            // Clear the search field value
            const searchField = document.getElementById("search-top-bar");
            if (searchField) {
                searchField.value = "";
            }

            setTimeout(() => document.getElementById('search-modal').value = '', 0);
        });
    }

    let vh = window.innerHeight * 0.01;
    const root = document.documentElement;

    function scrollbarVisible() {
        return jQuery(document).height() > jQuery(window).height();
    }

    jQuery(window).on('resize load scroll', function () {
        if (scrollbarVisible()) {
            root.style.setProperty('--scrollbar-width', (window.innerWidth - root.clientWidth) + "px");
        } else {
            root.style.setProperty('--scrollbar-width', '0px');
        }
        vh = window.innerHeight * 0.01;
        root.style.setProperty('--vh', `${vh}px`);
    });

    const stickyNavbar = document.getElementById("sticky-nav");
    const mainNavbar = document.getElementById("main-nav");
    let lastScrollTop = 0;
    let isMainNavVisible = false;

    // Intersection Observer to track if #main-navbar is visible
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                isMainNavVisible = entry.isIntersecting; // Update visibility state
                if (isMainNavVisible) {
                    stickyNavbar.classList.remove("visible"); // Hide sticky navbar when main nav is visible
                }
            });
        },
        { threshold: 0.1 } // Adjust threshold as needed
    );

    observer.observe(mainNavbar);

    // Scroll behavior for showing/hiding sticky navbar
    window.addEventListener("scroll", function () {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop) {
            // Scrolling down - hide sticky navbar
            stickyNavbar.classList.remove("visible");
        } else {
            // Scrolling up - show sticky navbar only if main nav is NOT visible
            if (!isMainNavVisible) {
                stickyNavbar.classList.add("visible");
            }
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Avoid negative scroll values
    });

});